import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import haxios from '../lib/haxios';

// Polls /notifications/unread-count on a fixed cadence and returns the number
// of unread notifications for the signed-in user. Shared by the ContextBar
// bell and the Rail's Notifications icon so both badges tick together.
//
// The endpoint (B-013) is optional server-side; older backends 404. We treat
// that as "no badge" (return 0) rather than a hard error so the UI degrades
// cleanly.

const POLL_MS = 30_000;

export const useNotificationsUnread = () => {
  const { apir } = useContext(GlobalContext);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!apir) return;
    let dead = false;
    const tick = async () => {
      try {
        const res = await haxios.get('/notifications/unread-count');
        if (dead) return;
        const n = typeof res === 'number'
          ? res
          : Number(res?.count ?? res?.unread ?? 0);
        setCount(Number.isFinite(n) && n >= 0 ? n : 0);
      } catch { /* endpoint may 404 in older BE builds — leave count at 0 */ }
    };
    tick();
    const id = setInterval(tick, POLL_MS);
    return () => { dead = true; clearInterval(id); };
  }, [apir]);

  return count;
};

export default useNotificationsUnread;
